import { chain } from 'lodash';
export const filterFulfilledResultsValues = (results) => chain(results)
    .map((result) => (result.status === 'fulfilled' ? result.value : null))
    .compact()
    .value();
export const filterRejectedResultsReasons = (results) => chain(results)
    .map((result) => (result.status === 'rejected' ? result.reason : null))
    .compact()
    .value();
export const wait = (time) => new Promise((resolve) => setTimeout(resolve, time));
